<template>
  <div class="add-to-cart js-add-to-cart" :class="{loading: isLoading}" @click.prevent="addToCart">
    <div class="spinner-border" role="status" v-if="isLoading"/>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.8872 16.547C23.0154 16.547 24.0083 15.9303 24.5197 14.9976L29.905 5.23488C30.4616 4.24206 29.7395 3.00855 28.5963 3.00855H6.333L4.91898 0H0V3.00855H3.00855L8.42395 14.426L6.39318 18.0965C5.29505 20.1122 6.73916 22.5642 9.02566 22.5642H27.077V19.5556H9.02566L10.6804 16.547H21.8872ZM7.76207 6.01711H26.039L21.8872 13.5385H11.3272L7.76207 6.01711ZM9.02566 24.0684C7.37095 24.0684 6.03215 25.4223 6.03215 27.077C6.03215 28.7317 7.37095 30.0855 9.02566 30.0855C10.6804 30.0855 12.0342 28.7317 12.0342 27.077C12.0342 25.4223 10.6804 24.0684 9.02566 24.0684ZM24.0684 24.0684C22.4137 24.0684 21.0749 25.4223 21.0749 27.077C21.0749 28.7317 22.4137 30.0855 24.0684 30.0855C25.7231 30.0855 27.077 28.7317 27.077 27.077C27.077 25.4223 25.7231 24.0684 24.0684 24.0684Z" fill="#FFAA00"/>
    </svg>
  </div>
</template>
<script setup lang="ts">
import { useCheckoutStore } from '~/store/checkout'
import {useModalsStore} from "~/store/modals";
import type { ApiDiagramDiagram } from '~/types/generated/contentTypes'

const { analytics } = useAnalytics()

const { diagram } = defineProps<{
  diagram: ApiDiagramDiagram,
}>()
const { addDiagramToCart } = useCheckoutStore()
const { showAddedToCartModal } = useModalsStore()
const isLoading = ref(false)
const addToCart = async () => {
  isLoading.value = true
  addDiagramToCart(diagram)
  await showAddedToCartModal(diagram)
  analytics.track('Add to cart', {event_category: 'Buy button'})
  isLoading.value = false
}
</script>

